import { PropsWithChildren } from 'react';
import styled from 'styled-components';
import { colors } from '../common/constants';
import { MainNav } from './MainNav';

export const Footer = styled.div`
  background-color: ${colors.primaryDark};
  color: #fff;
  font-size: 1rem;
  display: flex;
  padding: 20px;
  justify-content: center;
`;

export const StyledLayout = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

export const MainContent = styled.div`
  flex: 1;
  background-color: ${colors.background};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

export const DefaultLayout = ({ children }: PropsWithChildren<any>) => {
  return (
    <StyledLayout>
      <MainNav />
      <MainContent>{children}</MainContent>
      <Footer>
        <span>©2022 by Đào Tiên</span>
      </Footer>
    </StyledLayout>
  );
};
